<template>
  <div v-if="ambition?.title">
    <SplitContainerAmbition
      class="overflow-hidden"
      :ambition="parentAmbition"
      :limited-split-height="true"
    >
      <template #head>
        <div class="pb-10 lg:pb-12">
          <NuxtLink
            class="link-back-to mb-10 lg:mb-20"
            :to="localePath({name: 'ambitions-ambition', params: {ambition: parentAmbition?.slug}})"
          >
            {{ $t('Back to') }} {{ parentAmbition?.title }}
          </NuxtLink>
        </div>
      </template>

      <template #split>
        <div class="mx-auto grid max-w-6xl gap-4 bg-sand p-10 max-md:gap-y-10 md:gap-6 lg:grid-cols-2 lg:py-20">
          <details
            v-if="parentAmbition?.children"
            class="cursor-pointer rounded-3xl border border-black lg:hidden relative"
          >
            <summary class="flex items-center justify-between gap-4 px-5 py-3 font-bold">
              {{ ambition.title }}
              <IconsActionsChevron
                class="size-3"
                aria-hidden="true"
              />
            </summary>
            <div class="divide-y divide-black absolute bg-sand w-full border border-black rounded-3xl mt-4 overflow-clip">
              <template
                v-for="ambitionPage in parentAmbition.children"
                :key="ambitionPage.id"
              >
                <NuxtLink
                  v-if="ambition.id !== ambitionPage.id"
                  class="ambition-link block px-5 py-3 no-underline transition-none"
                  :to="localePath({name: 'ambitions-ambition-slug', params: {ambition: ambitionPage.parent?.slug, slug: ambitionPage.slug}})"
                >
                  {{ ambitionPage.title }}
                </NuxtLink>
              </template>
            </div>
          </details>
          <div class="max-lg:hidden">
            <AmbitionChildren
              :active-ambition="ambition"
              :color="parentAmbition?.color"
              :ambitions="parentAmbition?.children ?? []"
              class="mb-7 w-full !overflow-visible lg:mb-10"
            />
          </div>
          <SofieText
            class="p:first-of-type prose text-black prose-a:text-black prose-strong:text-black"
            :value="ambition.text"
          />
        </div>
      </template>
    </SplitContainerAmbition>

    <section class="container py-10 lg:py-20">
      <hero>
        <template #default>
          <SofieText
            class="hero-title green-question-suffix"
            :value="heroTitle"
          />
          <SofieText
            class="max-lg:hidden lg:pt-2.5 lg:text-white"
            :value="heroDesc"
          />
        </template>
      </hero>
      <div class="flex -translate-y-6 flex-col items-center">
        <Btn
          class="!mt-0"
          :to="localePath({name: 'about-us', hash: `#${$t('Vacancies').toLowerCase()}`})"
          :label="$t('Go to our vacancies')"
          :short-label="$t('Our vacancies')"
          centered
        />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {AmbitionDocument, type AmbitionQuery} from '~/graphql/graphql';

const route = useRoute();
const localePath = useLocalePath();

const {data: parentAmbitionData} = await useAsyncQuery<AmbitionQuery>(AmbitionDocument, {
  slug: route.params.ambition,
});

if (!parentAmbitionData.value?.ambition) {
  throw createError({statusCode: 404});
}
const parentAmbition = computed(() => parentAmbitionData.value.ambition!);

const color = ref(parentAmbition.value.color ?? '');

const {data: ambitionData} = await useAsyncQuery<AmbitionQuery>(AmbitionDocument, {
  slug: route.params.slug,
});

if (!ambitionData.value?.ambition) {
  throw createError({statusCode: 404});
}
const ambition = computed(() => ambitionData.value.ambition!);

const heroTitle = '<p>Heb jij hart voor een<br>gezonde generatie</p>';
const heroDesc = '<p>Door middel van onze<br>ambities werken we toe naar<br>een gezonde generatie.</p>';
</script>

<style scoped>
.ambition-link:hover {
  background-color: v-bind(color);
  color: #FFFFFF;
}
</style>
